import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import ('./ui/layout/flat/flat.component'),
        children: [
            {
                path: '',
                loadComponent: () => import ('./ui/pages/(flat)/home/home.component'),
            },
            {
                path: 'shoppers',
                loadComponent: () => import ('./ui/pages/(flat)/shoppers/shoppers.component'),
            },
            {
                path: 'sellers',
                loadComponent: () => import ('./ui/pages/(flat)/sellers/sellers.component'),
            },
            {
                path: 'partners',
                loadComponent: () => import ('./ui/pages/(flat)/partners/partners.component'),
            },
            {
                path: 'about-us',
                loadComponent: () => import ('./ui/pages/(flat)/about-us/about-us.component'),
            },
            {
                path: 'blogs',
                children: [
                    {
                        path: '',
                        loadComponent: () => import ('./ui/pages/(flat)/blogs/blog-list/blog-list.component'),
                    },
                    {
                        path: ':slug',
                        loadComponent: () => import ('./ui/pages/(flat)/blogs/single-blog/single-blog.component'),
                    }
                ]
            },
            {
                path: 'contact-us',
                loadComponent: () => import ('./ui/pages/(flat)/contact-us/contact-us.component'),
            },
            {
                path: 'privacy-policy',
                loadComponent: () => import ('./ui/pages/(flat)/legal-info/legal-info.component'),
            },
            {
                path: 'terms-of-service',
                loadComponent: () => import ('./ui/pages/(flat)/legal-info/legal-info.component'),
            }
        ]
    },
    /*{
        path: 'login',
        loadComponent: () => import ('./ui/pages/(auth)/login/login-choice/login-choice.component'),
    },*/
    {
        path: '',
        loadComponent: () => import ('./ui/layout/auth/auth.component'),
        children: [
            {
                path: 'login',
                loadComponent: () => import('./ui/pages/(auth)/login/login-form/login-form.component'),
                /*children: [
                    {
                        matcher: (segments) => {
                            const type = segments[0]?.path;
                            if (segments.length === 1 && (type === 'seller' || type === 'shopper')) {
                                return {
                                    consumed: segments,
                                    posParams: {
                                        type: segments[0],
                                    },
                                };
                            }
                            return null;
                        },
                        loadComponent: () => import('./ui/pages/(auth)/login/login-form/login-form.component'),
                    },
                ],*/
            },
            {
                path: 'sign-up',
                loadComponent: () => import ('./ui/pages/(auth)/sign-up/sign-up.component'),
            },
            {
                path: 'forgot-password',
                loadComponent: () => import ('./ui/pages/(auth)/forgot-password/forgot-password.component'),
            },
            {
                path: 'reset-password',
                loadComponent: () => import ('./ui/pages/(auth)/reset-password/reset-password.component'),
            }
        ]
    },
    {
        path: 'activate-account',
        loadComponent: () => import ('./ui/pages/activate-account/activate-account.component'),
    },
    {
        path: 'coming-soon',
        loadComponent: () => import ('./ui/pages/coming-soon/coming-soon.component'),
    }
];
